import Skeleton from 'react-loading-skeleton';


// widths（選填）：各欄百分比寬度，通常直接把 headerData 的 width 傳進來，
// 讓骨架的欄寬與真實表頭一致；沒傳就沿用原本的等寬行為。
const LoadingTable = ({ row, column, widths }) => {
  const columnCount = column ?? widths?.length ?? 0;
  const columnWidth = (idx) => widths?.[idx] ?? 100 / columnCount;

  return (
    <tbody>
      {Array.apply(null, Array(row)).map((data, index) => (
        <tr key={index}>
          {Array.apply(null, Array(columnCount)).map((data, idx) => (
            <td key={idx} width={`${columnWidth(idx)}%`}>
              <div style={{ width: `${100}%` }}>
                <Skeleton height={20} />
              </div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default LoadingTable;
